import { useState } from "react"
import { Alert } from "react-bootstrap"
import { useVrboQueryMetadataQuery } from "../../../services/bClientApi"
import QuickForm from "../../Forms/QuickForm/QuickForm"
import JSONData from "../../JSONData/JSONData"

const metadataTypes = [
    { value: 'locales', text: 'Locales' },
    { value: 'text-keys', text: 'Text Keys' },
    { value: 'prop-types', text: 'Property Types' },
    { value: 'booking-policies', text: 'Booking Policies' },
    { value: 'stay-policies', text: 'Stay Policies' },
    { value: 'prop-amenities', text: 'Property Amenities' },
    { value: 'unit-amenities', text: 'Unit Amenities' },
    { value: 'unit-spaces', text: 'Unit Spaces' },
]

export default function VrboMetadataSection() {
    const [metadataType, setMetadataType] = useState('')
    const { currentData, error, isFetching, refetch } = useVrboQueryMetadataQuery(metadataType, {
        skip: !metadataType,
    })
    const resultLabel = metadataTypes.find(type => type.value === metadataType)?.text
    const showResult = !!metadataType && !isFetching
    const handleClose = () => setMetadataType('')

    return (
        <section className="mt-4" aria-labelledby="vrbo-metadata-heading">
            <h4 id="vrbo-metadata-heading">VRBO Metadata</h4>
            <p className="text-muted">Look up supported values and fields for VRBO listings.</p>
            <QuickForm
                key={metadataType}
                initialData={{ metadataType }}
                fields={[
                    {
                        fieldName: 'metadataType',
                        fieldLabel: 'Metadata Type',
                        fieldType: 'select',
                        options: metadataTypes,
                        required: true,
                        disabled: isFetching,
                    },
                ]}
                onSubmit={(values: { metadataType: string }) => {
                    if (isFetching || !values.metadataType) return
                    if (values.metadataType === metadataType) {
                        refetch()
                    } else {
                        setMetadataType(values.metadataType)
                    }
                }}
                disabled={isFetching}
                submitText={isFetching ? 'Querying...' : 'Query Metadata'}
            />
            {isFetching && <p role="status">Loading VRBO metadata...</p>}
            {showResult && error && (
                <Alert variant="danger">
                    <p>Failed to query VRBO metadata. Try again.</p>
                    <JSONData data={error} title={`${resultLabel} Query Error`} onClose={handleClose} />
                </Alert>
            )}
            {showResult && !error && currentData !== undefined && (
                <JSONData data={currentData} title={`${resultLabel} Metadata`} onClose={handleClose} />
            )}
        </section>
    )
}
